import $ from "jquery";
import Choices from "choices.js";
// import "./StyledSelect";
import { StyledSelect } from "./StyledSelect";
//convert all selects on the page in Choices

export function openModals() {
  $("#areas-api-modal").modal("toggle");
}

StyledSelect(".country ", {});
if (document.getElementsByClassName("area").length > 0) {
  var area_1 = new Choices(".area", {
    noResultsText: "Nie znaleziono wyników",
    noChoicesText: "Brak możliwości wyboru",
    itemSelectText: "Naciśnij aby wybrać",
    searchPlaceholderValue: "Wyszukaj...",
    paste: false,
    shouldSortItems: false,
    shouldSort: false
  });
}

$("#country").change(function() {
  var name = $.trim($("#country option").text());
  var id = $("#country option").val();

  $.ajax({
    method: "POST",

    url: teik.ajax_url,
    data: {
      action: "teik_areasapi",
      name: name,
      id: id
    },
    success: function(data) {
      area_1.removeActiveItems();
      area_1.clearInput();

      var d = [];

      $.each(data.areas, (i, item) => {
        d[i] = {
          value: item.address_required,
          label: item.name + " " + "(" + item.area_code + ")"
        };
      });

      area_1.clearStore();
      area_1.setValue(["Wybierz strefę"]);
      area_1.setChoices(d);
    },
    dataType: "json"
  });
});

function showLoader() {
  $("#area-e").css("display", "block");
}
function hideLoader() {
  $("#area-e").css("display", "none");
}

$("#area").change(function() {
  var name = $.trim($("#country option").text());
  var id = $("#country option").val();
  var v = $("#area option").val();

  $.ajax({
    method: "POST",

    url: teik.ajax_url,
    data: {
      action: "teik_areasapi",
      name: name,
      id: id
    },
    success: function(data) {
      var result = document.getElementsByClassName("wrapper");
      var requirements = document.getElementsByClassName("requirements-item");
      $(".area_code_results").html("");
      var ids = $("#country option").val();
      var idsx = $("#country option");
      var z = id;
      var y = 1;
      var q = z + y;
      var m = $("#area option").text();
      var areaValue = $("#area option").val();
      var areaValueHTML = $("#area option").html();

      var i;

      for (i = 0; i < result.length; i++) {
        $(result[i]).css("display", "none");

        var p = [];

        if (result[i].dataset.id === ids) {

          let req = result[i].getElementsByClassName("requirements-item");

          for (let requirement of req) {
            let n = areaValueHTML.includes(requirement.dataset.name);

            if (!n) {
              requirement.style.display = "none";
            } else {
              requirement.style.display = "block";
            }


          }
          $.each(data.areas, (s, item) => {
            p.push(item.address_required);


          });



          $.each(p, ar => {});

          $(".area_code_results").append($.parseHTML(m));
          if (v == 1) {
            $(result[i]).css("display", "block");
            $(".none-wrap .requirements").text("");
          } else {
            $(".none-wrap").css("display", "block");
            $(".none-wrap .requirements").text(
              "Wystarczy podać adres siedziby swojej firmy. Może zaistnieć konieczność dostarczenia dokumentu potwierdzającego tożsamość."
            );
          }
        }
      }

      openModals();
    }
  });
});
